/* eslint-disable react/prop-types */
import React, { useEffect, useCallback, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { Checkbox, Button, message } from 'antd';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import { Header, Title } from '$app/shared/components/Header';
import Loading from '$app/shared/components/Loading';
import { getCampaignById, updateCampaign } from '../CampaignEditPage/actions';
import Menu from '../../components/Menu';
import { listAllProducts } from './actions';
import Styled from './styled';

const CheckboxGroup = Checkbox.Group;

const CampaignRequiredItemsPage = ({ history, match }) => {
  const campaignId = match.params.campaignId;
  const [state, setState] = useState({
    campaign: {},
    products: [],
    requiredItems: [],
  });

  const { campaign, products, requiredItems } = state;

  useEffect(() => {
    const fetchData = async () => {
      const response = await Promise.all([getCampaignById(campaignId), listAllProducts()])
        .then(([campaignData, allProducts]) =>
          setState((prevState) => ({
            ...prevState,
            campaign: campaignData,
            products: allProducts,
            requiredItems: campaignData.requiredItems,
          }))
        )
        .catch((err) => {
          message.error(err);
        });
      return response;
    };
    fetchData();
  }, [campaignId]);

  const closePageHandler = useCallback(() => history.push('/'), [history]);

  const onChange = (newCheckList) =>
    setState((prevState) => ({
      ...prevState,
      requiredItems: newCheckList,
    }));

  const onCheckAllChange = (e) => {
    if (e.target.checked) {
      return setState((prevState) => ({
        ...prevState,
        requiredItems: products,
      }));
    }
    return setState((prevState) => ({
      ...prevState,
      requiredItems: [],
    }));
  };

  const saveRequiredItems = () =>
    updateCampaign(campaignId, {
      requiredItems: JSON.stringify(requiredItems),
    })
      .then(() => message.info('Campaign required items have been updated'))
      .catch((error) => message.error(get(error, 'response.data.message') || 'Could not update campaign', 3));

  if (isEmpty(campaign)) return <Loading />;

  return (
    <Styled className="CampaignRequiredItemsPage">
      <Header className="justify">
        <Title>
          Campaign {campaignId}
          <Button type="link" onClick={closePageHandler} className="pull-right">
            <img src="/assets/images/close-black.svg" alt="close" style={{ cursor: 'pointer', height: 20 }} />
          </Button>
        </Title>
      </Header>
      <Menu selectedItem="requiredItems" campaignId={campaignId} history={history} />

      <div className="products">
        <Checkbox onChange={onCheckAllChange} checked={products.length === requiredItems.length}>
          Select all products
        </Checkbox>

        <div className="line" />

        <CheckboxGroup options={products} value={requiredItems} onChange={onChange} />

        <Button onClick={saveRequiredItems}>Save</Button>
      </div>
    </Styled>
  );
};

export default withRouter(CampaignRequiredItemsPage);
